<template>
  <div> 
    <div>
      <div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          :row-class-name="rowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="device_name"
            width="200"
            label="仪器名称">
          </el-table-column>
          <el-table-column
            prop="bar_code"
            width="100"
            label="二维码">
          </el-table-column>
          <el-table-column
            class="col-width"
            width="100"
            label="方式">
            <template slot-scope="scope">
              <span>{{measureArr[scope.row.measure_type]}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            class="col-width"
            width="100"
            label="价格">
          </el-table-column>
          <el-table-column
            prop="cnas"
            width="100"
            label="CNAS">
            <template slot-scope="scope">{{ scope.row.cnas | cnas_filter}}</template>
          </el-table-column>
          <el-table-column
            prop="measure"
            width="150"
            label="范围">
          </el-table-column>
          <el-table-column
            prop="grade"
            width="150"
            label="等级">
          </el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope" class="cell-sp" >

              <div class="block-col block-col-bottom">
                <el-button class="op-detail-btn" @click="handleUpdateDevice(scope.row)">修改信息</el-button>
                <el-button class="op-apply-btn" @click="handleDrop(scope.row, scope.$index)">放弃</el-button>
                <el-button class="op-detail-btn" @click="handleDevice(scope.row, scope.$index)"> 退样 </el-button>
              </div>

              <div class="block-col block-col-bottom">
                <el-button class="op-detail-btn" @click="handleUpdate(scope.row, scope.$index)">修改价格</el-button>
                <el-button  class="op-apply-btn"
                  v-if="scope.row.service_type == 2 || scope.row.service_type == 3"
                  @click="handleOut(scope.row, scope.$index)">委外完成</el-button>
                <el-button
                  v-else
                  class="op-apply-btn"
                  @click="handleApply(scope.row)"
                  >
                  规程
                </el-button>
                <el-button v-if="scope.row.service_type != 2 && scope.row.service_type != 3" class="op-detail-btn" @click="handleEquip(scope.row)">标准量具</el-button>
              </div>
              <div class="block-col" v-if="scope.row.service_type != 2 && scope.row.service_type != 3">

                <!-- 证书模版 -->
                <el-button
                  class="op-detail-btn"
                  @click="getTemplate(scope.row)"
                  >
                  证书模版
                </el-button>
                <el-button class="op-apply-btn"  @click="goSend(scope.row)">证书</el-button><!-- :disabled="temp_btn" -->
                <el-button
                  class="op-detail-btn"
                  @click="handleFinish(scope.row, scope.$index)"
                  >
                  录入完成
                </el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改弹窗框 start -->
    <el-dialog
      title="修改规程"
      class="parameters-container parameters update-rule-container"
      :visible.sync="sendShow" >
      <div class="name-content">
        <div class="name-top">
          <el-input
            class="search-input"
            placeholder="请搜索内容"
            prefix-icon="el-icon-search"
            v-model="search"
            @keyup.enter.native="searchName"
            ><!-- searchItemFpRule -->
            <!--  -->
          </el-input>
        </div>
        <ul class="name-table">
          <li class="left-list list-title"><span class="text">规程选择</span></li>
          <!-- <el-checkbox-group v-model="rulesList" @change="rulesChoose" v-if="updateRules.rules.length > 0"> -->
          <template v-if="updateRules.rules.length > 0">
            <li class="left-list" v-for="item in updateRules.rules" :key="item.rule_id" @click="ruleAdd(item)" :class="{'list-color': item.choose}">
              <span class="text">{{item.code}} {{item.name}}</span>
            </li>
            </template>
          <!-- </el-checkbox-group> -->
          <li class="center-list" v-else>
            <!-- <i class="el-icon-loading" v-if="rulesLoading"></i> -->
            <div class="none-text">暂无数据</div>
          </li>
        </ul>
      </div>
      <!-- 添加按钮 -->
      <div class="add-content">
        <div class="add" :aria-disabled="true" >添加</div> <!--  @click="addRules" -->
      </div>
      <!-- 选择规程 -->
      <div class="right-content">
        <ul class="right-table">
          <li class="left-list list-title"><span class="text">已经选择规程</span></li>
          <template v-if="updateRules.rule.length > 0">
            <li class="left-list" v-for="item in updateRules.rule" :key="item.rule_id">
              <span class="text">{{item.code}} {{item.name}}</span>
              <i class="op-delete-icon el-icon-error" @click="deleteRule(item)"></i>
            </li>
          </template>
          <li class="center-list" v-else>
            <!-- <i class="el-icon-loading" v-if="rightLoading"></i> -->
            <div class="none-text" >该仪器没有选择规程</div><!-- v-else -->
          </li>
          <li class="left-list">
            <el-button class="save-btn" @click="saveUpadate">保存</el-button>
          </li>
        </ul>
      </div>
    </el-dialog>
    <!-- 修改 标准计量器具 start -->
    <el-dialog
      title="修改标准计量器具"
      class="parameters-container parameters-equips"
      @close="closeEquip"
      :visible.sync="equipShow">
        <div class="equip-update-content">
          <div class="equip-update-left">
            <div class="name-top">
              <el-input
                class="search-input"
                placeholder="请搜索内容"
                prefix-icon="el-icon-search"
                v-model="search_equip"
                @keyup.enter.native="searchEquip"
                ><!-- searchItemFpRule -->
                <!--  -->
              </el-input>
            </div>
            <el-table
              ref="equipTable"
              class="left-table-equip"
              @selection-change="handleSelectionChange"
              :data="equipsList.equips">
              <el-table-column
                type="selection"
                width="30">
              </el-table-column>
              <el-table-column
                prop="name"
                label="名称"></el-table-column>
              <el-table-column
                prop="cert_code"
                label="证书编号"></el-table-column>
              <el-table-column
                prop="next_date"
                label="日期"></el-table-column>
              <el-table-column
                prop="grade"
                label="等级"></el-table-column>
              <el-table-column
                prop="measure"
                label="范围"></el-table-column>
              <el-table-column
                prop="model"
                label="型号"></el-table-column>
              <el-table-column
                prop="vendor"
                label="厂家"></el-table-column>
            </el-table>
          </div>
          <div class="add-content">
            <div class="add" :aria-disabled="true" >添加</div> <!--  @click="addRules" -->
          </div>
          <div class="equip-update-right">
            <ul class="right-table">
              <li class="left-list list-title"><span class="text">已经选择器具</span></li>
              <template v-if="equipsList.equip.length > 0">
                <li class="left-list" v-for="(item) in equipsList.equip" :key="item.rule_id">
                  <span class="text">{{item.name}}</span>
                  <i class="op-delete-icon el-icon-error" @click="deleteEquip(index)"></i>
                </li>
              </template>
              <li class="center-list" v-else>
                <!-- <i class="el-icon-loading" v-if="rightLoading"></i> -->
                <div class="none-text" >该仪器没有选择器具</div><!-- v-else -->
              </li>
            </ul>
          </div>
        </div>
      <el-button class="save-equip-btn" @click="saveEquips">保存</el-button>
    </el-dialog>
    <!-- 修改 标准计量器具 end -->
    <!-- 修改信息 start -->
    <el-dialog
      title="信息修改"
      class="parameters-container parameters"
      :visible.sync="update_detail_show">
      <el-form class="update-container" >
        <el-form-item class="input-list" label="仪器名称" prop="dev_name">
          <el-input placeholder="请输入仪器名称" type="text" v-model="update_detail.dev_name"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="型号规格" prop="device_serial">
          <el-input placeholder="请输入仪器的型号规格" type="text" v-model="update_detail.device_serial"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="证书编号" prop="cert_code">
          <el-input placeholder="请输入仪器的证书编号" type="text" v-model="update_detail.cert_code"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="生产厂家" prop="vendor">
          <el-input placeholder="请输入生产厂家" type="text" v-model="update_detail.vendor"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="器具编号" prop="equip_code">
          <el-input placeholder="请输入器具编号" type="text" v-model="update_detail.equip_code"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="CNAS" prop="cnas">
          <el-radio-group class="radio-content" @change="radioChange" v-model="update_detail.cnas">
            <el-radio class="radio-list" :label="0">不带CNAS</el-radio>
            <el-radio class="radio-list" :label="1">带CNAS</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input-list" label="校准日期" prop="cert_date">
          <el-date-picker
            class="date-input"
            type="date"
            v-model="update_detail.cert_date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"></el-date-picker>
        </el-form-item>        
        <el-form-item class="input-list" label="到期日期" prop="next_date">
          <el-date-picker
            class="date-input"
            type="date"
            v-model="update_detail.next_date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"></el-date-picker>
        </el-form-item>        
        <el-form-item class="input-list" label="地点" prop="place">
          <el-input placeholder="请输入校准地点" type="text" v-model="update_detail.place"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="温度" prop="temperature">
          <el-input placeholder="请输入温度值" type="text" v-model="update_detail.temperature"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="湿度" prop="humidity">
          <el-input placeholder="请输入湿度值" type="text" v-model="update_detail.humidity"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="备注" prop="memo">
          <el-input :rows="4" placeholder="请输入备注" type="textarea" v-model="update_detail.memo"></el-input>
        </el-form-item>
        <el-form-item class="btn-list">
          <el-button class="btn btn-save" @click="updateDetailSend" >保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 修改信息 end -->
    <!-- 修改价格 start -->
    <el-dialog
      title="价格修改"
      class="parameters-container parameters"
      :visible.sync="updateShow">
       <el-form class="update-container" :model="price" ref="price" :rules="rules">
          <el-form-item class="btn-list" >
            <el-button class="btn" @click="updateDeviceCat" >修改仪器</el-button>
          </el-form-item>
          <el-form-item class="input-list" label="仪器名称">
            <p class="input-list"> {{device.device_name}}  </p><br/>
          </el-form-item>
          <el-form-item class="input-list" label="范围">
            <p class="input-list"> {{device.measure}}  </p><br/>
          </el-form-item>
          <el-form-item class="input-list" label="等级">
            <p class="input-list"> {{device.grade}}  </p>
          </el-form-item>
          <el-form-item class="input-list" label="价格" prop="price">
            <el-input placeholder="请输入修改价格" type="number" v-model="price.price"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="原因" prop="memo">
            <el-input :rows="4" placeholder="请输入修改价格的原因" type="textarea" v-model="price.memo"></el-input>
          </el-form-item>
          <el-form-item class="btn-list">
            <el-button class="btn btn-save" @click="priceSend('price')" >保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 修改价格 end -->
    <el-dialog title="修改仪器类型" class="parameters-container parameters" :visible.sync="deviceCatShow" width="50%">
        <div v-for="device_cat in device_cats" :key="device_cat.device_cat_id" >
          <input type="radio" v-model="price.device_cat_id" name="price.device_cat_id" :value="device_cat.device_cat_id" > {{device_cat.device_name}} | {{device_cat.measure}} | {{device_cat.grade}}
        </div>
        <button class="btn-cat-apply" @click="changeDeviceCat" > 确定  </button>
    </el-dialog>
    <!-- 证书模版start -->
    <el-dialog
      title="选择模版"
      class="parameters-container parameters-equips parameters-temp"
      @close="closeTemp"
      :visible.sync="tempShow">
      <el-table
        ref="tempTable"
        :data="tempObj.templates"
        @selection-change="tempChange">
        <el-table-column
          type="selection"
          width="30">
        </el-table-column>
        <el-table-column
          prop="template_name"
          label="模版姓名"></el-table-column>
        <el-table-column
          prop="user_name"
          label="工程师"></el-table-column>
        <el-table-column
          prop="create_time"
          label="日期"></el-table-column>
      </el-table>
      <div class="input-list">
        <el-button class="save-btn" @click="tempSave">保存</el-button>
      </div>
    </el-dialog>
    <!-- 证书模版 end -->
    <!-- <div  class="delete-container" v-if="comShow">
      <div class="delete-content">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
        <p class="delete-txt">确认参数录入已经完成?</p>
        <div class="btn-container">
          <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
          <el-button class="btn-list sure-btn" @click="sureCom">确认</el-button>
        </div>
      </div>
    </div> -->
    <!-- 委外完成 弹框 start -->
    <el-dialog
      title="委外完成"
      class="parameters-container parameters"
      :visible.sync="outShow">
       <el-form class="update-container" :model="out"><!-- :model="price" ref="price" :rules="rules" -->
          <el-form-item class="input-list" label="结果" >
            <el-select class="options-select"  v-model="out.result" placeholder="请选择" >
              <el-option
                v-for="item in options"
                :key="item.result_id"
                :label="item.result_name"
                :value="item.result_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="input-list" label="证书编号" >
            <el-input type="text" v-model="out.cert_code" ></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="器具编号" >
            <el-input type="text" v-model="out.equip_code" ></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="仪器名称" >
            <el-input type="text" v-model="out.name" ></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="仪器型号" >
            <el-input type="text" v-model="out.model" ></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="价格" >
            <el-input type="text" v-model="out.price" ></el-input>
          </el-form-item>
          <el-form-item label="证书日期" class="input-list input-top">
            <el-date-picker
              class="date-input"
              type="date"
              v-model="out.cert_date"
              placeholder="请选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="有效日期" class="input-list input-top">
            <el-date-picker
              class="date-input"
              type="date"
              v-model="out.next_date"
              placeholder="请选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="input-list" label="备注" >
            <el-input type="txt-area" v-model="out.memo" ></el-input>
          </el-form-item>
          <el-form-item class="btn-list">
            <el-button class="btn btn-save" @click="outSend">保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 委外完成 弹框 end -->
    <!-- 退样 放弃 弹框 start -->
    <div  class="delete-container" v-if="deviceShow">
      <div class="delete-content">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
        <p class="delete-txt">{{show_detail.text}}</p>
        <div class="btn-container">
          <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
          <el-button class="btn-list sure-btn" @click="sureFun">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 退样 放弃 弹框 end -->
  </div>
</template>

<script type='text/ecmascript-6'>
import base from 'common/js/base.js' 
import moment from 'moment'
export default {
  data () {
    return {
      lab_order_id: '',
      empty: '订单没有仪器信息！',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      search_name: '',
      measureArr: ['校准', '检定', '检测'],
      sendShow: false ,
      comShow: false,
      device: {},
      deviceIndex: '',
      parameters: [],
      deviceShow: false,
      updateShow: false,
      price: {
        device_cat_id: 0,
        price: '',
        memo: ''
      },
      rules: {
        price: [{
          required: true, message: '请输入修改的价格', trigger: 'blur'
        }],
        memo:[{
          required: true, message: '请输入修改价格的原因', trigger: 'blur'
        }]
      },
      updateRules: {
        rules: [],
        rule: [],
      },
      addRule: {},
      rulesList: [],
      search: '',
      search_equip: '',
      equipsList: {
        equips: [],
        equip: []
      },
      equips: [],
      updateCopy: [],
      equipShow: false,
      tempShow: false,
      tempObj: {
        templates: []
      },
      temp_btn: true,
      step: 0,
      outShow: false,
      options: [
        {
          result_id: 1,
          result_name: '退样'
        }, {
          result_id: 0,
          result_name: '合格'
        }, {
          result_id: 5,
          result_name: '损坏'
        }, {
          result_id: 4,
          result_name: '丢失'
        }
      ],
      out: {},
      deviceCatShow: false,
      device_cats: [],
      show_detail: { },
      update_detail: {},
      update_detail_show: false,
      update_noninitial: false
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    rowClass({ row }) {
      if (row.type == 1) {
        return 'row-color'
      }
    },
    initData () { // 初始化页面 发送 订单ID 获取订单详情
      let that = this
      this.lab_order_id = this.$route.query.lab_order_id
      this.type =  this.$route.query.type
      let fun = '';
      if (this.$route.query.kind == 'in') {
        fun = 'seeReceivedDeviceDetail'
      } else {
        fun = 'seeReceivedDeviceDetailOut'
      }
      this.$api[fun]({
        lab_order_id: that.lab_order_id,
        type: that.type,
        page_num: (that.page-1)  * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.device.length > 0) {
          that.tableData = res.data.device
          this.total = Number(res.data.total)
        } else {
          that.tableData = []
          this.total = 0
        }
      }).catch(err => {
        this.$message({
          message: err,
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      this.initData()
    },
    handleApply (row) { // 规程修改
      this.device = {...row}
      let that = this
      that.$api.updateDeviceRule({
        item_id: row.item_id,
        type: row.type
      }).then(res => {
        if (res.data.rules.length > 0){
          // that.updateRules = {...res.data}
          if (res.data.rule.length > 0) {
            that.rulesList = res.data.rule.map(item => { // 点击发送规则ID
              return item.rule_id
            })
            res.data.rules.forEach(item => {
              let index = that.rulesList.findIndex(id => {
                return id == item.rule_id
              })
              if (index === -1) {
                item.choose = false
              } else {
                item.choose = true
              }
            })
          }
          that.updateRules = {...res.data}
          that.sendShow = true
        } else if(res.data.rules.length === 0) {
          that.$message({
            type: 'error',
            message: `请添加规程`,
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    rulesChange(val) { // 规程修改 标准计量器具
      if (val.length > 0) {
        this.updateRules.rule = [...val]
      } else {
        this.$message({
          type: 'error',
          message: ' 规程至少选择一个！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    handleEquip(row) { // 点击击标准计量器具
      this.device = {...row}
      let that = this
      that.$api.updateDeviceEquip({
        item_id: row.item_id,
        type: row.type
      }).then(res => {
        if (res.data.equips.length > 0){
          // that.equipsList = {...res.data}
          let equip_copy = []
          res.data.equip.forEach(item => {
            let eq = res.data.equips.filter(eqiup => {
              return eqiup.equip_id == item.equip_id
            }).pop()
            equip_copy.push(eq)
          })

          that.equipsList = {...res.data}
          that.equipShow = true
          that.$nextTick(() => {
            that.setEquip(equip_copy)
          })
        } else if (res.data.equips.length == 0) {
          that.$message({
            type: 'error',
            message: `请添加标准计量器具`,
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    setEquip(rows) {
      let that = this
      rows.forEach(item => {
        if (item) {
          that.$refs.equipTable.toggleRowSelection(item, true)
        } else {
          that.$refs.equipTable.clearSelection()
        }
      })
    },
    // 标准计量器具
    handleSelectionChange(val) {
      if (val.length > 0 || this.equipsList.equip.length > 0)  {
        this.equipsList.equip = val.map(item => {
          return item
        })
      } else {
        this.$message({
          type: 'error',
          message: ' 标准计量器具至少选择一个！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    ruleAdd(rule){
      let arr = []
      arr = this.updateRules.rule.filter(item => {
        return item.rule_id ===  rule.rule_id
      });
      this.updateRules.rules.forEach(item => {
        if (item.rule_id == rule.rule_id) {
          item.choose  = true
        }
      })
      if (arr.length === 0) {
        this.updateRules.rule.push(rule)
      }
      this.rulesList = this.updateRules.rule.map(item => { // 点击发送规则ID
        return item.rule_id
      })
    },
    deleteRule(rule) { // 规程规程管理删除
      let index = this.updateRules.rule.findIndex(item => {
        return item.rule_id ===  rule.rule_id
      });
      this.updateRules.rules.forEach(item => {
        if (item.rule_id ===  rule.rule_id) {
          item.choose = false
        }
      })
      if (index !== -1) {
        this.updateRules.rule.splice(index, 1)
      }
      this.rulesList = this.updateRules.rule.map(item => { // 点击发送规则ID
        return item.rule_id
      })
    },
    // 保存 规程 修改
    saveUpadate() {
      let that = this
      if (that.rulesList.length) {
        that.$api.updateDeviceSaveRule({
          item_id: that.device.item_id,
          type: that.device.type,
          rules: [...that.rulesList]
        }). then(res => {
          if (res.data.msg === true) {
            that.$message({
              type: 'success',
              message: ' 保存成功！！',
              customClass: 'msg-position',
              showClose: true
            });
            that.sendShow = false
          } else {
            that.$message({
              type: 'error',
              message: `${res.data.error}`,
              customClass: 'msg-position',
              showClose: true
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: ' 规程 至少选择一个！！'
        })
      }
    },
    searchName() { //规程管理搜索
      let that = this
      if (!that.search) {
        that.$message({
          type: 'error',
          message: `请输入搜索内容`,
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      that.$api.searchItemFpRule({
        device_type:  that.updateRules.device_type,
        search: that.search
      }).then(res => {
        if(res.data.length > 0) {
          res.data.forEach(item => {
            let index = that.rulesList.findIndex(id => {
              return id == item.rule_id
            })
            if (index === -1) {
              item.choose = false
            } else {
              item.choose = true
            }
          })
          that.updateRules.rules = res.data
        } else {
          that.$message({
            type: 'error',
            message: `没有该规程`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    closeEquip() {
      this.$refs.equipTable.clearSelection()
    },
    // 右侧标准计量器具删除
    deleteEquip(index){
      let that = this
      that.equipsList.equip.splice(index, 1)
    }, 
    searchEquip() {
      // searchItemFpEquip
      let that = this
      if (!that.search_equip) {
        that.$message({
          type: 'error',
          message: `请输入搜索内容`,
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      that.$api.searchItemFpEquip({
        device_type:  that.equipsList.device_type,
        search: that.search_equip
      }).then(res => {
        if(res.data.length > 0) {
          let equipVar = {...that.equipsList}
          equipVar.equips = [...res.data]
          let equip_copy = []
          equipVar.equip.forEach(item => {
            let eq = equipVar.equips.filter(eqiup => {
              return eqiup.equip_id == item.equip_id
            }).pop()
            equip_copy.push(eq)
          })
          that.equipsList = {...equipVar}
          that.$nextTick(() => {
            that.setEquip(equip_copy)
          })
        } else {
          that.$message({
            type: 'error',
            message: `没有该标准计量器具`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    // 标准计量保存
    saveEquips() {
      let that = this
      if (that.equipsList.equip.length) {
        let arr = that.equipsList.equip.map(item => item.equip_id)
        that.$api.updateDeviceSaveEquip({
          item_id: that.device.item_id,
          type: that.device.type,
          equips: [...arr]
        }). then(res => {
          if (res.data.msg === true) {
            that.$message({
              type: 'success',
              message: ' 保存成功！！',
              customClass: 'msg-position',
              showClose: true
            })
            that.$refs.equipTable.clearSelection()
            that.equipShow = false
          } else {
            that.$message({
              type: 'error',
              message: `${res.data.error}`,
              customClass: 'msg-position',
              showClose: true
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: '标准计量器具至少选择一个！！'
        })
      }
    },
    goSend(row) { // 证书生成及编辑
      this.device = {...row}
      let that = this
      that.$api.officeFor({
        detail_id: this.device.detail_id,
        type: that.device.type
      }).then(res => {
        if(res.data.msg== true) {
          var md5 = require('md5');
          let local_type = parseInt(that.device.type) + base.jl_online;
          let da = md5(`jl001${local_type}-${that.device.detail_id}`)
          let url = `${base.office}${da}`;
          that.openHtml(url);
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    openHtml(URL) {
      let  temp_form = document.createElement("form");
      temp_form.action = URL;
      temp_form.target = "_blank";
      temp_form.method = "post";
      temp_form.style.display = "none";
      let opt = document.createElement("input");
      opt.name="access_token";
      opt.value="证书参数"
      temp_form.appendChild(opt);
      document.body.appendChild(temp_form);
      temp_form.submit();
    } ,
    parametersSend () {
      let that = this
      let parameters = this.parameters
      let params = []
      parameters.forEach(item => {
        let param = {}
        param.id = item.id
        param.value = item.value
        params .push(param)
      })
      if (params.length > 0 && that.device.bar_code) {
        that.postRequest('web_lab/insert_data.php', {
          bar_code: that.device.bar_code,
          data_list: JSON.stringify(params)
        }).then(res => {
          that.sendShow = false
          if (res.data.msg === true) {
            that.$message({
              type: 'success',
              message: '参数录入成功！！',
              customClass: 'msg-position',
              showClose: true
            })
          } else {
            that.$message({
              type: 'error',
              message: `${res.data.error}`,
              customClass: 'msg-position',
              showClose: true
            })
          }
        })
      }
    },
    /* handleCom(row, index) { // 点击申请
      this.device = row
      this.deviceIndex = index
      this.comShow = true
    },
    sureCom () { // 参数录入点击保存
      let that = this
      that.$api.throughDevice({
        item_id: that.device.item_id,
        qr_code: that.device.bar_code
      }).then(res => {
        if (res.data.msg === true) {
          that.comShow = false
          that.initData()
          that.$message({
            type: 'success',
            message: '参数录入完成！！',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '参数录入还没有完成！！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    }, */
    cancleDelete () { // 取消此操作
      if (this.comShow) {
        this.comShow = false
      }
      if (this.deviceShow) {
        this.deviceShow = false
      }
      if (this.update_detail_show) {
        this.update_detail_show = false
      }
      this.$message({
        type: 'info',
        message: '取消此操作！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    handleDevice (row, index) { // 退样
      this.device = {...row}
      this.show_detail = {
        type: 'didWorkDel',
        text: '确认把该仪器进行退样?'
      }
      this.deviceShow = true
      this.deviceIndex = index
    },
    handleDrop(row, index) { // 放弃领取
      this.device = {...row}
      this.show_detail = {
        type: 'dropDevice',
        text: '确认把该仪器放弃？'
      }
      this.deviceShow = true
      this.deviceIndex = index
    },
    handleFinish(row, index) { // 录入完成
      this.device = {...row}
      this.show_detail = {
        type: 'finishInput',
        text: '确认数据录入已完成？'
      }
      this.deviceShow = true
      this.deviceIndex = index
    },
    sureFun () {
      if (this.show_detail.type == 'didWorkDel'){ // 退样确定
        this.sureDevice()
      }
      else if (this.show_detail.type == 'dropDevice') { // 放弃确定
        this.dropDevice()
      }
      else if (this.show_detail.type == 'finishInput') {  // 录入完成
        this.excelCom()
      }
    },
    sureDevice () { // 退样确定请求后台
      let that = this
      that.$api.didWorkDel({
        detail_id: this.device.detail_id,
        type: that.device.type
      }).then(res => {
        if (res.data.msg === true) {
          that.deviceShow = false
          that.$message({
            type: 'success',
            message: '退样成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.initData()
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    dropDevice() { // 放弃后请求后台消息
      let that = this
      that.$api.dropDevice({
        item_id: this.device.item_id,
        type: that.device.type
      }).then(res => {
        if (res.data.msg === true) {
          that.deviceShow = false

          that.$message({
            type: 'success',
            message: '放弃成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.initData()
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    handleUpdate (row, index) { // 修改价格
      this.device = {...row}
      this.updateShow = true
      this.deviceIndex = index
    },
    handleUpdateDevice(row) { // 修改信息 点击
      this.device = {...row}
      let that = this
      that.$api.getItemInfo({
        item_id: this.device.item_id,
        type: that.device.type
      }).then(res => {
        if(res.data.item_id) {
          this.update_detail_show = true
          this.update_detail = {...res.data, cnas: Number(res.data.cnas)}
        } else {
          that.$message({
            type: 'error',
            message: `修改信息获取错误`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    radioChange(e) {
      this.update_detail.cnas = e
    },
    updateDetailSend(){ // 修改信息保存
      let that = this
      that.$api.saveItemInfo({
        ...that.update_detail,
        item_id: this.device.item_id,
        type: that.device.type
      }).then(res => {
        if (res.data.msg == true) {
          that.$message({
            type: 'success',
            message: '修改信息保存成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          this.update_detail_show = false
          that.initData()
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    handleOut (row, index) { // 点击委外完成
      this.device = {...row}
      this.outShow = true
      this.deviceIndex = index
      let next = new Date(moment(new Date()).format('YYYY-MM-DD'))
      next.setFullYear(next.getFullYear()+1)
      next.setDate(next.getDate()-1)
      this.out = {
        result: 0,
        cert_date: moment(new Date()).format('YYYY-MM-DD'),
        next_date: moment(next).format('YYYY-MM-DD'),
        name: this.device.dev_name,
        model: this.device.device_serial,
        equip_code: this.device.equip_code,
        cert_code: this.device.cert_code,
        price: this.device.price,
        memo: this.device.memo
      }
    },
    outSend () { // 点击  委外完成 保存
      let that = this
      that.$api.sendOut({
        detail_id: that.device.detail_id,
        ...that.out
      }).then(res => {
        if (res.data.msg === true) {
          this.$message({
            type: 'success',
            message: '委外完成保存成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          this.outShow = false
          // this.tableData.splice(this.deviceIndex, 1)
          that.initData()
        } else if (res.data.msg === false) {
          this.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    updateDeviceCat() {
      let that = this
      this.$api.getSameDeviceInfo({
        dev_name_id: this.device.device_name_id
      }).then(res => {
        if (res.data.length > 0) {
          that.device_cats = res.data
          that.deviceCatShow = true
        } else {
          that.$message({
            type: 'error',
            message: '获取仪器信息失败！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    changeDeviceCat() {
      this.deviceCatShow = false
      for (var i=0; i<this.device_cats.length; i++) {
        if (this.device_cats[i].device_cat_id == this.price.device_cat_id) {
          this.device.device_name = this.device_cats[i].device_name
          this.device.measure = this.device_cats[i].measure
          this.device.grade = this.device_cats[i].grade

          this.price.price = this.device_cats[i].price
          if (this.price.memo == '') {
            this.price.memo = '仪器范围等级调整'
          }
          break
        }  
      }
    },
    priceSend (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.updatePrice({
            item_id: that.device.item_id,
            type: that.device.type,
            device_cat_id: that.device.device_cat_id,
            ...that.price
          }).then(res => {
            this.updateShow = false
            if (res.data.msg === true) {
              // that.tableData[that.deviceIndex].price = that.price.price
              that.initData()
              that.price= {}
              this.$message({
                type: 'success',
                message: '价格修改成功保存成功！！',
                customClass: 'msg-position',
                showClose: true
              })
            } else {
              this.$message({
                type: 'error',
                message: '修改价格失败！！',
                customClass: 'msg-position',
                showClose: true
              })
            }
          }).catch(err => {
            this.$message({
              type: 'error',
              message: err,
              customClass: 'msg-position',
              showClose: true
            })
          })
        }
      })
    },
    getTemplate(row) { // 获取证书模版
      let that = this
      this.device = {...row}
      that.$api.getItemfpTemplates({
        item_id:row.item_id,
        type: row.type
      }).then(res => {
        if(res.data.templates.length > 0) {
          that.tempObj = {...res.data}
          if(that.tempObj.current) {
            let item = that.tempObj.templates.filter(item => {
              return item.template_id == that.tempObj.current
            }).pop()
            that.tempObj.check = item
            that.tempObj.copy_id = that.tempObj.current
            if (item) {
              that.temp_btn = false
            }
            that.$nextTick(() => {
              that.$refs.tempTable.toggleRowSelection(that.tempObj.check,true)
            })
          }
          that.tempShow = true
        } else {
          this.$message({
            type: 'error',
            message: '证书模版没有获得！！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    closeTemp() {
      this.$refs.tempTable.clearSelection()
    },
    tempChange(val) {
      if (val.length === 1) {
        this.tempObj.check = val.pop()
        this.tempObj.current = this.tempObj.check.template_id
      }else if (val.length > 1 )  {
        this.tempObj.check = val.pop()
        this.$refs.tempTable.clearSelection()
        this.tempObj.current = this.tempObj.check.template_id
        this.$refs.tempTable.toggleRowSelection(this.tempObj.check)
      }
      if (this.tempObj.copy_id == this.tempObj.current) {
        this.temp_btn = false
      } else {
        this.temp_btn = true
      }
    },
    tempSave() { // 模版保存
      let that = this
      if (that.tempObj.current) {
        that.$api.saveItemfpTemplate({
          item_id: that.device.item_id,
          type: that.device.type,
          template_id: that.tempObj.current,
          step: that.step
        }).then(res => {
          if(res.data.msg === true) {
            that.$message({
              type: 'success',
              message: '模版选择保存成功！！',
              customClass: 'msg-position',
              showClose: true
            })
            that.step = 0
            that.temp_btn = false
            that.tempShow = false
          } else if (res.data.error_id == 1){
            that.$confirm(`${res.data.error}`,'提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.step = 1
              that.tempSave()
            }).catch(() => {
              that.step = 0
              that.$message({
                type: 'info',
                message: '已取保存操作',
                customClass: 'msg-position',
                showClose: true
              })
            })
          }
          else{
            that.step = 0
            that.$message({
              type: 'error',
              message: '模版选择保存失败！！',
              customClass: 'msg-position',
              showClose: true
            })
          }
        })
      } else {
        that.$message({
          type: 'error',
          message: '请选择证书模版！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    excelCom() { // 证书录入完成
      let that = this
      that.$api.didWork({
        detail_id: this.device.detail_id,
        type: that.device.type
      }).then(res => {
        if(res.data.msg === true){
          that.$message({
            type: 'success',
            message: '证书生成成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.initData()
          // that.tableData.splice(index, 1)
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
        that.deviceShow = false
      })
    }
  },
  filters: {
    // CNAS状态
    cnas_filter(state) {
      if (state == 0) {
        return '不带CNAS'
      }
      if (state == 1) {
        return '带CNAS'
      }
    }
  },
  components: {
  },
  watch: {
    update_detail_show: function(val) {
      if (val) {
        this.update_noninitial = false;
      }
    },
    'update_detail.cert_date': {
      immediate: false,
      handler(val) {
        if (this.update_noninitial && (val != '')) {
          var newDate = new Date(val)
          newDate.setFullYear(newDate.getFullYear() + 1)
          newDate.setDate(newDate.getDate() - 1)
          this.update_detail.next_date = newDate.toISOString().slice(0,10)
        }
        this.update_noninitial = true
      },
    },
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/mixin.styl'
  @import '~common/stylus/box.styl' 
  .op-delete-icon
    flex: 0 0 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color:#979797;
  .cell
    display: flex;
    flex-direction: column;
    .block-col
      &.block-col-bottom
        margin-bottom: 0.5rem
        display:inline-block
      .op-detail-btn
        height:1.4rem;
        width:5rem;
        font-size:0.7rem;
        background:#00AF00;
        padding:0 0rem
        span
          color:white;
      .op-apply-btn
        background:#7070FF;
        height:1.4rem;
        width:5rem;
        font-size:0.7rem;
        padding:0 0rem
        span
          color:white
  .parameters-temp
    thead
      .el-checkbox
        display:none;
    .input-list
      display: flex;
      justify-content: space-between;
      margin-top:1rem;
      .save-btn
        background: #48beaa;
        border-radius: 0.05rem;
        height: 1.8rem;
        padding: 0 5rem;
        border:none;
        outline:none;
        span
          color:#fff;
      .apply-btn
        display: flex;
        justify-content: center;
        flex-direction: column;
        border-radius: 0.05rem;
        background: #404040;
        height: 1.8rem;
        padding: 0 5rem;
        border:none;
        outline:none;
        font-size:0.7rem;
        span
          color:#fff;
      .is-disabled
        opacity: 0.6;
        &:hover
          background: #404040;
  .parameters-container.parameters-equips
    display:flex;
    justify-content: center;
    align-items: center;
    .el-dialog
      margin:0px !important;
      width:auto;
    .el-dialog__header
      height:3rem;
      padding:0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1D489E;
      .el-dialog__title
        color: #fff;
      .el-dialog__headerbtn
        .el-icon
          color:#fff;
          font-size: 1.2rem;
    .el-dialog__body
      display: flex;
      flex-direction: column;
      .save-equip-btn
        margin-top: 2rem;
        height: 1.6rem;
        padding: 0.2rem 1rem;
        background: #1d489e;
        border-radius: 0.1rem;
        border: none;
        span
          color:#fff;
  &.equip-update-content
    display: flex;
    .equip-update-left
      flex: 1;/**/
      .name-top
        border: 0.05rem solid #e5e5e7;
        .search-input
          .el-input__inner
            height:1.6rem;
            border: 0.05rem solid #e5e5e7;
          .el-input__prefix
            .el-icon-search
              color: #c7c6cb;
      .left-table-equip
        max-height: 20rem;
        width:100%;
        overflow-y: auto;
        overflow-x: hidden;
    .add-content
      flex: 0 0 4rem;
      margin: 0 1rem;
      width: 4rem
      display: flex;
      justify-content: center;
      align-items: center;
      .add
        width:3.6rem;
        height:2.1rem;
        font-size:0.7rem;
        bg-image('~assets/add_bg.png');
        color:#fff;
        text-align:center;
        line-height:2.1rem;
    .equip-update-right
      flex: 0 0 10rem;
      width:12rem;
      max-height:20rem;
      margin-top: 2rem;
      flex:1;
      border: 0.02rem solid #ececec;
      overflow-y:auto;
      overflow-x: hidden;
      .left-list
        width:100%;
        border-bottom: 0.05rem solid #ececec;
        padding: 0.5rem;
        box-sizing:border-box;
        display: flex;
        .text
          flex:1;
          display:flex;
          justify-content: center;
          align-items: center;
          font-size:0.7rem;
          color:#4c4c4c;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        .save-btn
          background: #1d489e;
          width: 100%;
          span
            color:#fff
        &.list-title
          height:2.3rem;
          background-color:#ecf0f8;
          display:flex;
          justify-content: center;
          align-items: center;
          .text
            font-size:0.8rem;
            color:#4c4c4c;
            font-weight:bold;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
      .center-list
        height:3rem;
        display:flex;
        justify-content:center;
        align-items: center;
        .none-text
          font-size:0.8rem;
          color:#666;
  .parameters-container.parameters
    display:flex;
    justify-content: center;
    align-items: center;
    .el-dialog
      margin:0px !important;
      width: auto; 
    .el-dialog__header
      height:3rem;
      padding:0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1D489E;
      .el-dialog__title
        color: #fff;
      .el-dialog__headerbtn
        .el-icon
          color:#fff;
          font-size: 1.2rem;
    .update-container
      border: 0;
      padding: 0 0.5rem;
      width:20rem;
      .input-list
        display: flex;
        margin-bottom: 0rem;
        &.is-error
          .el-form-item__content
            .el-input
              .el-input__inner
                border: 0.05rem solid #EF757A;
        .el-form-item__label
          color:#474747;
          font-size:0.7rem
          flex: 0 0 4rem;
          text-align: left;
        .el-form-item__content
          position:relative;
          min-height:2rem;
          flex: 1;
          display: flex;
          .el-input
            height:2rem;
            flex:1;
            .el-input__inner
              padding: 0 0.8rem;
              border: 0.05rem solid #cfcfcf;
            &.date-input
              width:100%;
              .el-input__inner
                /* padding: 0 1rem; */
              .el-input__prefix
                display:none;
          .options-select
            width:100%;
          .el-form-item__error
            left: 0.8rem;
            background:#fff;
            color:#EF757A;
      .radio-content
        display: flex;
        align-items: center;
        .radio-list
          color: #666;
          font-size: 0.7rem;
          .el-radio__label
            color:#666;
          &.is-checked
            .el-radio__label
              color:#666;
          .el-radio__input
            .el-radio__inner
              border:0;
              width: 1rem;
              height:1rem;
              background-color:#fff;
              bg-image('~assets/radio.png');
          &.is-checked
            .el-radio__inner
              bg-image('~assets/radio_checked.png');
      .btn-list
        width:100%;
        padding:0;
        .el-form-item__content
          width: 100%;
          display: flex;
          .btn
            flex: 1;
          .btn-delete
            background: #EF757A;
            span
              color:#fff;
          .btn-save
            background:#1D489E;
            span
              color:#fff;
    .form-container
      border: 0;
      padding: 0 1rem;
      box-sizing:border-box;
      .input-list
        width:100%;
        display: flex;
        margin-bottom: 0.5rem;
        .save-equip-btn
          width: 100%;
          margin-top: 2rem;
          height: 1.6rem;
          padding: 0.2rem 1rem;
          background: #1d489e;
          border-radius: 0.1rem;
          border: none;
          span
            color:#fff;
        .el-form-item__label
          color:#474747;
          font-size:0.7rem
          flex: 0 0 5rem;
          width:5rem;
          text-align: left;
        .el-form-item__content
          flex: 1;
          max-width:20rem;
          .check-content
            height: 100%;
            margin-bottom: 0;
            display: flex;
            /* justify-content: center; */
            align-items: center;
            flex-wrap: wrap;
            .check-list
              /* margin-bottom: 0.5rem; */
              display: flex;
              .el-checkbox__input
                flex: 0 0 0.8rem;
                width:0.8rem;
              .el-checkbox__label
                flex: 1;
                word-wrap:break-word;
                white-space:pre-wrap;
              &.is-checked
              .el-checkbox__input
                &.is-checked
                  .el-checkbox__label
                    color:#666;
                  .el-checkbox__inner
                    background-color:#fff;
                    bg-image('~assets/checked.png');
                    &::after
                      display:none;
                .el-checkbox__inner
                  width:0.8rem;
                  height:0.8rem;
                  background-color:#fff;
                  border:0px;
                  bg-image('~assets/check.png');
      .tk-btn-content
        .el-form-item__content
          width:100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .tk-save
            background: #48beaa;
            border-radius: 0.05rem;
            height: 1.6rem;
            padding: 0 1.5rem;
            border:none;
            outline:none;
            span
              color:#fff;
      .btn-list
        width:100%;
        padding:0;
        .el-form-item__content
          width: 100%;
          display: flex;
          .btn
            flex: 1;
          .btn-delete
            background: #EF757A;
            span
              color:#fff;
          .btn-save
            background:#1D489E;
            span
              color:#fff;
  .update-rule-container .el-dialog__body
    display:flex;
    flex-direction: row;
    .name-content
      flex: 1;
      .name-top
        width:100%;
        height:1.6rem;
        .search-input
          .el-input__inner
            height:1.6rem;
            border: 0.05rem solid #e5e5e7;
          .el-input__prefix
            .el-icon-search
              color: #c7c6cb;
      .name-table
        max-height:20rem;
        margin-top:0.8rem;
        border: 0.02rem solid #ececec;
        overflow-y:auto;
        overflow-x: hidden;
        .left-list
          width:100%;
          border-bottom: 0.05rem solid #ececec;
          padding:0.5rem;
          box-sizing:border-box;
          display: flex;
          .text
            color:#666;
            font-size:0.7rem;
            word-wrap:break-word;
            word-break: break-all;
            white-space: normal;
            cursor: default;
          &.list-title
            height:2.3rem;
            background-color:#ecf0f8;
            display:flex;
            justify-content: center;
            align-items: center;
            .text
              font-size:0.8rem;
              color:#4c4c4c;
              font-weight:bold;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              text-align:center;
          &.list-color
            background-color: #eff;
        .center-list
          height: 3rem;
          display:flex;
          justify-content:center;
          align-items: center;
          .none-text
            font-size:0.8rem;
            color:#666;
    .add-content
      flex: 0 0 4rem;
      margin: 0 1rem;
      width: 4rem
      display: flex;
      justify-content: center;
      align-items: center;
      .add
        width:3.6rem;
        height:2.1rem;
        font-size:0.7rem;
        bg-image('~assets/add_bg.png');
        color:#fff;
        text-align:center;
        line-height:2.1rem;
    .right-content
      max-height:20rem;
      margin-top: 2rem;
      flex:1;
      border: 0.02rem solid #ececec;
      overflow-y:auto;
      overflow-x: hidden;
      .left-list
        width:100%;
        border-bottom: 0.05rem solid #ececec;
        padding: 0.5rem;
        box-sizing:border-box;
        display: flex;
        .text
          flex:1;
          display:flex;
          justify-content: center;
          align-items: center;
          font-size:0.7rem;
          color:#4c4c4c;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        .save-btn
          background: #1d489e;
          width: 100%;
          span
            color:#fff
        &.list-title
          height:2.3rem;
          background-color:#ecf0f8;
          display:flex;
          justify-content: center;
          align-items: center;
          .text
            font-size:0.8rem;
            color:#4c4c4c;
            font-weight:bold;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
      .center-list
        height:3rem;
        display:flex;
        justify-content:center;
        align-items: center;
        .none-text
          font-size:0.8rem;
          color:#666;
  .delete-container
    position:fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background-color:rgba(0, 0, 0, 0.2);
    z-index:10000;
    display: flex;
    justify-content: center;
    align-items: center;
    .delete-content
      background:#fff;
      z-index: 100001;
      width: 20rem;
      padding: 2rem 1rem;
      border-radius: 0.4rem;
      position: relative;
      .delete-title
        text-align:center;
        font-size:0.8rem;
        .el-icon-warning
          color:red;
          font-size:1rem;
      .delete-txt
        text-align: center;
        margin-top:1rem;
        font-size:0.9rem;
        font-weight:medium;
        color:#666;
      .btn-container
        margin-top:1.5rem;
        padding: 0rem 2rem;
        width:100%;
        color: #666;
        box-sizing:border-box;
        display: flex;
        .btn-list
          flex:1;
          color:#fff;
          border:0;
          &.cancle-btn
            background: #cfcfcf;
            color:#fff;
            span
              color:#fff;
          &.sure-btn
            background: #EF757A;
            span
              color:#fff;
      .close-icon
        position: absolute;
        top:0.5rem;
        right:0.5rem;
        color:#9a9a9a;
        font-size:1.2rem;
.btn-cat-apply
  margin-top:0.6rem;
  width: 4rem;
  height: 2rem;
  background:#1D489E;
  color:#fff;
  font-size: 0.7rem;
</style>
